import InvoiceEditor from '@/pages/dashboard/finance/components/InvoiceEditor';

export default function NewInvoicePage() {
  return <InvoiceEditor docType="invoice" />;
}